module.exports = __webpack_public_path__ + "img/Ja-studio.300ec7e8.gif";